import Alert from './common/alerts/Alert.vue'
import TextAlert from './common/alerts/TextAlert.vue'
import Multiselect from 'vue-multiselect'

export default {
  install (Vue) {
    Vue.component('alert', Alert)
    Vue.component('text-alert', TextAlert)
    Vue.component('exclude-toggle', require('./common/ExcludeToggle').default)
    Vue.component('multiselect', Multiselect)
  }
}



// WEBPACK FOOTER //
// ./src/global-components.js